import React, { useState, useEffect } from 'react';

import api from "../../../../../services/api";

import AddEstagio from './AddEstagio';
import List from './List';
import { Button } from "reactstrap";


export default ({ notify, empresa, funilId, ...props }) => {

    const [estagios, setEstagios] = useState([]);
    const [showAddEstagio, setShowAddEstagio] = useState(false);


    useEffect(() => {
        if (funilId) loadEstagiosFunil();
    }, [empresa, funilId])

    async function loadEstagiosFunil() {
        try {
            const response = await api.get(`/common/empresas/${empresa.id}/funis/${funilId}/estagios`);
            const data = await response.data
            setEstagios(data ? data : []);
        } catch (error) {
            console.error(error);
            notify('danger', 'Não foi possível carregar estagios do funil');
        }
    }

    return (
        <>
            <div
                style={{
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center'
                }}
            >
                <AddEstagio
                    empresa={empresa}
                    funilId={funilId}
                    estagios={estagios}
                    onSuccess={loadEstagiosFunil}
                    show={showAddEstagio}
                    notify={notify}
                    close={() => setShowAddEstagio(false)}
                />
            </div>
            <List
                estagios={estagios}
                empresa={empresa}
                funilId={funilId}
                reload={loadEstagiosFunil}
                notify={notify}
            />
        </>
    );
}
